import React from 'react';
import { NumericFormat } from 'react-number-format';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function parseQueryString(queryString) {
  let params = {},
    queries,
    temp,
    i,
    l;
  queries = queryString.split('&');

  for (i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split('=');
    params[temp[0]] = temp[1];
  }
  return params;
}

export function getQueryStringParams() {
  return parseQueryString(window.location.hash.substring(window.location.hash.indexOf('?') + 1));
}

export function formatPrice(price, currency = 'EUR') {
  const html = document.getElementsByTagName('html');
  const lang = html ? html[0].lang : null;
  let prefix = '€ ';
  let suffix = '';
  let priceFormatted = <span>-,--</span>;

  if (currency && price && price > 0) {
    if (currency === 'EUR') {
      if (lang && (lang === 'en' || lang === 'de')) {
        prefix = '€ ';
        suffix = '';
      }
    } else if (currency === 'HUF') {
      if (lang && (lang === 'en' || lang === 'de')) {
        prefix = 'Ft ';
        suffix = '';
      }
    }

    return (
      <NumericFormat
        value={price}
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        decimalScale="2"
        fixedDecimalScale
        prefix={prefix}
        suffix={suffix}
      />
    );
  }

  return priceFormatted;
}

export function insertAfter(el, referenceNode) {
  referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export function parseReceiptNumber(url) {
  const regex = /receiptnumber=([0-9]*)&/g;
  let m;

  while ((m = regex.exec(url)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    return m[1] ? m[1] : null;
  }
}

export function isAustrianIBAN(iban) {
  return iban ? iban.toUpperCase().indexOf('AT') === 0 : false;
}

export function selectObjectValueByPath(path, obj) {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj);
}

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} location={location} />;
  }

  return ComponentWithRouterProp;
}

/**
 *
 * @param {string|undefined} previous
 * @param {string|undefined} current
 * @param {string|undefined} next
 * @param {Function} navigate
 * @param {Object} location
 * @returns
 */
export function makeLinks(previous, current, next, navigate, location) {
  const ret = {
    backLink: undefined,
    nextLink: undefined
  };

  if (previous !== null) {
    ret.backLink = {
      url: previous,
      go: () => (location.state.from === previous ? navigate(-1) : navigate(previous, { replace: true }))
    };
  }

  if (next !== null) {
    ret.nextLink = {
      url: next,
      go: () => navigate(next, { state: { from: current } })
    };
  }

  return ret;
}
